import axios from "axios";

const api = axios.create({
 // baseURL: "http://127.0.0.1:8000/api",
   baseURL: "https://zarvika.meshink.xyz/backend/public/api",
  headers: {
    Accept: "application/json",
  },
});

// Automatically attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // console.log("Token:", token);
  return config;
});

export default api;
